import { render, staticRenderFns } from "./ListProjectMobile.vue?vue&type=template&id=2f04dcf8&scoped=true&"
import script from "./ListProjectMobile.vue?vue&type=script&lang=js&"
export * from "./ListProjectMobile.vue?vue&type=script&lang=js&"
import style0 from "./ListProjectMobile.vue?vue&type=style&index=0&id=2f04dcf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04dcf8",
  null
  
)

export default component.exports